import { Injectable } from '@angular/core';
import { CART_NORMALIZER } from '../../../features/cart/base/connector/converters';
import { ShoppingList } from '../../model';
import { Occ } from '../../occ/occ-models';
import { Converter, ConverterService } from '../../util';

@Injectable({ providedIn: 'root' })
export class ShoppingListNormalizer implements Converter<Occ.CartTemplate, ShoppingList> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.CartTemplate, target?: ShoppingList): ShoppingList {
    if (source) {
      if (target === undefined) {
        target = { ...(source as any) };
      }
      target = this.convertShoppingList(source);
    }

    return target;
  }

  private convertShoppingList(source: Occ.CartTemplate): ShoppingList {
    if (source) {
      const { reader, writer, owner, readers, writers, ...target } = source;
      const cart = this.converter.convert(target, CART_NORMALIZER);
      return {
        ...cart,
        reader,
        writer,
        owner,
        readers,
        writers,
        numberOfArticles: cart.entries?.length,
      };
    } else {
      return undefined;
    }
  }
}
